import focus from '../directives/focus'

export function install(app) {
  app.directive('focus', focus)
}
